export const SITE_NAME = 'Tarcontent Developers Limited'

export const SITE_DESCRIPTION = 'Tarcontent Developers Limited Your Partner for sure.'
